import { Filter } from 'iconoir-react'
import React, { memo, useEffect, useRef, useState } from 'react'
import MainLayout from '../layouts/MainLayout'
import { WORK_STATUS } from '../utils/constants'
import { Spin, message } from 'antd'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Button, useTheme } from '@mui/material'
import queryString from 'query-string'
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import UnreadText from '../components/common/UnreadText'
import {
  findCreater,
  findHandler,
  getNameInCapitalize,
  TextWrap,
} from '../utils/common'
import { EmptyText } from '../components/common/CellText'
import moment from 'moment'
import { DATE_FORMAT_SLASH } from '../utils/constants'
import EmptyData from '../components/image/EmptyData'
import SkeletonTable from '../components/Skeleton/SkeletonTable'
import SearchAdvance from '../modules/work/SearchAdvanceModal'
import ContentModal from '../components/dialog/ContentModal'
import HandlerModal from '../components/dialog/HandlerModal'
import WorkTable from '../modules/work/WorkTable'
import { MdManageAccounts, MdOutlineTimer } from 'react-icons/md'
// import ScrollArea from 'react-scrollbar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'
import {
  AiFillCaretRight,
  AiFillStar,
  AiOutlineCheckCircle,
  AiOutlineStar,
} from 'react-icons/ai'
import { FcOk } from 'react-icons/fc'
import CreateModal from '../modules/work/CreateModal'
import utils from '../utils'
import Message from '../components/common/Message'
import { useMediaQuery } from 'react-responsive'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box className="pt-2 ">
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}
const WorkPage = props => {
  const [message, setMessage] = useState('')
  const [openMessage, setOpenMessage] = useState(false)
  const [severity, setSeverity] = useState('')
  const createMessage = (message, openMessage, severity) => {
    setMessage(message)
    setOpenMessage(openMessage)
    setSeverity(severity)
  }
  const { workStore, selectPeopleStore, notificationStore } = props
  const { workList, queryParams } = workStore
  const location = useLocation()
  const queryStringParsed = queryString.parse(location.search, {
    arrayFormat: 'index',
  })
  const navigate = useNavigate()
  const [openCre, setOpenCre] = useState(false)
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    title: null,
    to_date: null,
    from_date: null,
    status: null,
    permission: null,
    title: null,
  })
  const [isRefreshPage, setIsRefreshPage] = useState(true)
  const [loading, setLoading] = useState(true)

  const [openSearchAdvance, setOpenSearchAdvance] = useState(false)

  const [openContent, setOpenContent] = useState(false)
  const [openHandler, setOpenHandler] = useState(false)
  const [workSelect] = useState({})

  const getWorkList = async params => {
    try {
      await workStore.getWorkList(params)
    } catch (error) {
      console.log(error)
    } finally {
    }
  }

  useEffect(() => {
    const params = {
      page: queryStringParsed?.page || filter.page,
      size: queryStringParsed?.size || filter.size,
      title: queryStringParsed?.title || filter.title,
      is_unread: queryStringParsed?.is_unread || filter.is_unread,
      is_important: queryStringParsed?.is_important || filter.is_important,
      status: queryStringParsed?.status || filter.status,
      to_date: queryStringParsed?.to_date || filter.to_date,
      from_date: queryStringParsed?.from_date || filter.from_date,
      permission: queryStringParsed?.permission || filter.permission,
    }

    setFilter(params)
    ;(async () => {
      setLoading(true)
      workStore.clearWorkList()
      await getWorkList(params)
      setLoading(false)
      setIsRefreshPage(false)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (isRefreshPage) return
    const queryStringStringify = queryString.stringify(filter, {
      skipNull: true,
    })
    navigate({ pathname: '/work', search: queryStringStringify })
    ;(async () => {
      try {
        setLoading(true)
        workStore.clearWorkList()
        await getWorkList(filter)
        setLoading(false)
      } catch (err) {
        console.log(err)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])
  // const myRef = useRef(null)

  // useEffect(() => {
  //   const myDiv = myRef.current
  //   myDiv.addEventListener(
  //     'touchmove',
  //     function (event) {
  //       event = event.originalEvent || event
  //       if (event.scale !== 1) {
  //         event.preventDefault()
  //       }
  //     },
  //     false
  //   )
  // }, [])
  function createData(
    title,
    calories,
    fat,
    carbs,
    important,
    status,
    has_subwork,
    code,
    parent_id
  ) {
    return {
      title,
      calories,
      fat,
      carbs,
      important,
      status,
      has_subwork,
      code,
      parent_id,
    }
  }
  const isMobile = useMediaQuery({ maxWidth: 768 })
  const theme = useTheme()
  const formatData = dataList => {
    return dataList.map(record =>
      createData(
        <div
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
            lineHeight: '25px',
            WebkitLineClamp: '2',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            maxHeight: '50px',
            padding: '4px',
            color: theme.color.primary,
          }}>
          {record?.title}
        </div>,
        <UnreadText
          text={
            record?.assignees &&
            getNameInCapitalize(
              findHandler(record?.assignees)[0]?.name_uppercase
            )
          }
          isUnread={checkUnread(record)}
          width={'100%'}
        />,
        <UnreadText
          text={
            <div className="flex gap-2 items-center justify-center">
              <MdManageAccounts
                size={14}
                color={theme.color.primary}
                style={{
                  margin: isMobile ? '0 4px' : '0 5px',
                  minWidth: '10px',
                }}
              />
              <div style={{ fontSize: 12 }}>
                {record?.assignees &&
                  findCreater(record?.assignees).map(item =>
                    getNameInCapitalize(item.name_uppercase)
                  )}
              </div>
              <AiFillCaretRight
                style={{
                  margin: isMobile ? '0 4px' : '0 5px',
                  minWidth: '10px',
                  color: theme.color.primary,
                }}
                size={14}
              />
            </div>
          }
          isUnread={checkUnread(record)}
          width={'100%'}
        />,
        <UnreadText
          text={
            <div className="flex gap-2 items-center justify-center">
              <MdOutlineTimer color={theme.color.primary} size={14} />
              <div style={{ fontSize: 12, minWidth: '68px' }}>
                {record?.due_date ? (
                  moment(record?.due_date).format(DATE_FORMAT_SLASH)
                ) : (
                  <TextWrap>
                    <EmptyText>Không rõ</EmptyText>
                  </TextWrap>
                )}
              </div>
            </div>
          }
          isUnread={checkUnread(record)}
          width={'100%'}
        />,
        record?.important === true ? (
          <AiFillStar size={14} color="rgb(255,199,0)" />
        ) : (
          <AiOutlineStar size={14} />
        ),
        record?.status === WORK_STATUS.COMPLETE ? (
          <FcOk size={14} />
        ) : (
          <AiOutlineCheckCircle size={14} color="#a2a2a2" />
        ),
        record?.import,
        record?.code,
        record?.parent_id
      )
    )
  }
  const checkUnread = record => record.is_read !== true
  const rows = formatData(workList)
  const [value, setValue] = useState(0)
  const [hasMore, setHasMore] = useState(false)
  const [searchParams] = useSearchParams()
  const permissionParam = searchParams.get('permission')
  useEffect(() => {
    if (permissionParam === 'CREATE') {
      setValue(1)
    } else if (permissionParam === 'PIC') {
      setValue(2)
    } else if (permissionParam === 'VIEW') {
      setValue(3)
    } else {
      setValue(0)
    }
  }, [])
  const handleChange = async (event, newValue) => {
    setValue(newValue)
    let permission = ''
    if (newValue === 1) {
      permission = 'CREATE'
    } else if (newValue === 2) {
      permission = 'PIC'
    } else if (newValue === 3) {
      permission = 'VIEW'
    }
    setHasMore(true)
    workStore.clearWorkList()
    setFilter({ ...filter, permission: permission })
    workStore.clearWorkStore()
  }

  const fetchMoreData = async () => {
    if (workList.length >= workStore.totalWork) {
      setHasMore(false)
      return
    }
    workStore.setQueryParams({
      page: workStore.defaultQueryParams.page + 1,
      size: 10,
      permission: filter.permission,
    })
    try {
      await getWorkList({
        ...filter,
        page: workStore.defaultQueryParams.page,
        size: 10,
        permission: workStore.defaultQueryParams.permission,
      })
    } catch (err) {
      console.log(err)
    }
  }
  const [check, setCheck] = useState(false)
  const [checkV2, setCheckV2] = useState(false)

  useEffect(() => {
    workStore.clearWorkStore()
  }, [check, checkV2])
  useEffect(() => {
    if (workList.length <= workStore.totalWork) {
      setHasMore(true)
      return
    }
    workStore.clearWorkStore()
  }, [check, checkV2])
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    ;(queryStringParsed.document_code || queryStringParsed.mission_code) &&
      setOpenCre(true)
    if (workStore.workList.length === 0) {
      workStore.setQueryParams({
        ...queryParams,
        ...queryStringParsed,
        assignee: queryStringParsed.assignee
          ? queryStringParsed.assignee.join('&')
          : null,
        page: 0,
      })
      ;(async () => {
        try {
          // Ẩn lọc công việc theo tháng theo yêu cầu mới
          // workStore.setFilter('toDateWork', moment().format(ISO_DATE_FORMAT))
          // workStore.setFilter('fromDateWork', moment().subtract(30, 'd').format(ISO_DATE_FORMAT))
          // await workStore.getWorkList()
          // await fetchDetails()
        } catch (err) {
          console.log(err)
          message.error(err?.vi || 'Đã có lỗi xảy ra!')
        } finally {
        }
      })()
    }
    return () => {
      selectPeopleStore.clearSelectPeopleStore()
      workStore.clearWorkStore()
      notificationStore.clearNotificationType()
      workStore.clearQueryParams()
    }
  }, [])

  return (
    <div
      // ref={myRef}
      style={{ background: theme.background.base, minHeight: '850px' }}>
      <div
        className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px] fixed w-full z-50"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}>
        <div className="font-bold text-[28px] leading-[29px]  ">Công việc</div>
        <span
          className="w-5 cursor-pointer"
          onClick={() => {
            setOpenSearchAdvance(true)
          }}>
          <Filter />
        </span>
      </div>
      <MainLayout initialValue={3}>
        <div className="pl-2 pr-2 pt-20">
          <Box className="" sx={{}}>
            <Box sx={{}}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example">
                <Tab
                  className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                  label="Tất cả"
                  {...a11yProps(0)}
                />
                <Tab
                  className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                  label="Đã tạo"
                  {...a11yProps(1)}
                />
                <Tab
                  className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                  label="Xử lý"
                  {...a11yProps(2)}
                />
                <Tab
                  className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                  label="Theo dõi"
                  {...a11yProps(3)}
                />
              </Tabs>
            </Box>
          </Box>
          <Button
            variant="contained"
            color="primary"
            style={{ margin: '10px', textTransform: 'none' }}
            onClick={() => setOpenCre(true)}>
            Tạo mới công việc
          </Button>
          {/* <Button
            variant="contained"
            color="primary"
            style={{ margin: '10px' }}
            onClick={() => message.warning('Tính năng đang được phát triển')}>
            Tạo mới công việc
          </Button> */}
          {loading ? (
            <SkeletonTable />
          ) : workList?.length > 0 ? (
            <>
              <section className="mt-1 pb-[30px] overflow-x-auto hideScrollbar work-table">
                <InfiniteScroll
                  dataLength={workList.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  style={{
                    scrollSnapStop: 'always',
                  }}
                  loader={
                    <div
                      style={{
                        paddingTop: 20,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      {workList.length > 10 ? <Spin tip="Đang tải..." /> : ''}
                    </div>
                  }>
                  <div>
                    <div>
                      {rows?.map((row, index) => (
                        <WorkTable key={index} row={row} />
                      ))}
                    </div>
                  </div>
                </InfiniteScroll>
              </section>{' '}
            </>
          ) : (
            <EmptyData />
          )}
        </div>
        <SearchAdvance
          openSearchAdvance={openSearchAdvance}
          handleOpenSearchAdvance={() => {
            setOpenSearchAdvance(true)
          }}
          handleCloseSearchAdvance={() => {
            setOpenSearchAdvance(false)
          }}
          setFilter={setFilter}
          filter={filter}
          checkV2={checkV2}
          setCheckV2={setCheckV2}
        />
        <ContentModal
          open={openContent}
          handleClose={() => {
            setOpenContent(false)
          }}
          content={workSelect?.content}
        />
        <HandlerModal
          open={openHandler}
          handleClose={() => {
            setOpenHandler(false)
          }}
          handler={findHandler(workSelect?.assignees || [])}
        />
        <CreateModal
          createMessage={createMessage}
          queryStringParsed={queryStringParsed}
          params={setFilter}
          open={openCre}
          handleClose={() => {
            setOpenCre(false)
          }}
          check={check}
          setCheck={setCheck}
        />
        <Message
          message={message}
          openMessage={openMessage}
          severity={severity}
          closeMessage={() => {
            setOpenMessage(false)
          }}
        />
      </MainLayout>
    </div>
  )
}

export default inject(
  'workStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'notificationStore'
)(observer(WorkPage))
